// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2m0O0","description":"App_description__1S0Fa","add":"App_add__3G2p8"};